/**
 * use-yards — active yards for the dispatch-board yard/region tab filter
 * (Wave 3 Part 2 / Quick 260615-uf9). GET /v1/yards (VIEW_DRIVER_MAP).
 */

import { useApiQuery, useApiOpts } from '@lodex-pro/web-shared';

export interface Yard {
  readonly id: string;
  readonly name: string;
}

interface YardsResponse {
  readonly yards: readonly Yard[];
}

export const YARDS_QUERY_KEY = ['yards', 'list'] as const;

export function useYards(
  apiOpts: ReturnType<typeof useApiOpts>,
): ReturnType<typeof useApiQuery<YardsResponse>> {
  return useApiQuery<YardsResponse>(apiOpts, '/v1/yards', {
    queryKey: YARDS_QUERY_KEY,
    staleTime: 300_000,
  });
}
